import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=7d24ca4a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d24ca4a')) {
      api.createRecord('7d24ca4a', component.options)
    } else {
      api.reload('7d24ca4a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=7d24ca4a&", function () {
      api.rerender('7d24ca4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4xK9BRlRhAyvI/JS/comp/ImgFallback.vue"
export default component.exports